import React from 'react';
import { CartProvider } from './context/CartContext';
import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Categories from './components/Categories';
import ProductGrid from './components/ProductGrid';
import Bundles from './components/Bundles';
import Comparison from './components/Comparison';
import CareGuide from './components/CareGuide';
import Reviews from './components/Reviews';
import FAQ from './components/FAQ';
import Footer from './components/Footer';
import CartDrawer from './components/CartDrawer';
import Notification from './components/Notification';

function App() {
  return (
    <CartProvider>
      <div className="min-h-screen bg-[#faf9f6] text-zinc-800 font-sans selection:bg-red-200">
        <Navbar />
        <main>
          <Hero />
          <Categories />
          <ProductGrid />
          <Bundles />
          <Comparison />
          <CareGuide />
          <Reviews />
          <FAQ />
        </main>
        <Footer />
        <CartDrawer />
        <Notification />
      </div>
    </CartProvider>
  );
}

export default App;